import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Box, UnorderedList } from '@chakra-ui/react';
import { NavListGroup } from '../NavListGroup/component.js';
var _excluded = ["onItemClick", "groups"];
var NavList = function NavList(_ref) {
  var onItemClick = _ref.onItemClick,
    groups = _ref.groups,
    rest = _objectWithoutProperties(_ref, _excluded);
  /**
   * DOM
   */
  if (!groups || !groups.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    as: "nav",
    "data-object-type": "nav-list-container"
  }, /*#__PURE__*/React.createElement(UnorderedList, _extends({
    spacing: 3,
    margin: 0
  }, rest), groups.map(function (group, index) {
    return /*#__PURE__*/React.createElement(NavListGroup, _extends({
      key: index,
      "data-object-type": "nav-list-group",
      onItemClick: onItemClick
    }, group));
  })));
};
NavList.displayName = "NavList";
export { NavList };